module.exports = __webpack_public_path__ + "img/rainbowmakifrontal.251979b3.jpg";